
import { mapGetters } from 'vuex';

import ImgLoader from '@/components/core/img-loader/img-loader.vue';
import MuscleLogo from '@/components/MuscleCharge/MuscleLogo.vue';
import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';

import { getFooterLinksByBrand, getPrivacyAndTermsByBrand } from './main-footer.service';

export default {
  components: { ImgLoader, MuscleLogo },
  props: {
    hasDisclaimer: {
      type: Boolean,
      default: true,
    },
    brand: {
      type: String,
      default: PROJECT_BRANDS.reverse,
    },
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapGetters('footer', ['getFooterStatus']),
    isReverseBrand() {
      return this.brand === PROJECT_BRANDS.reverse;
    },
    isMuscleChargeBrand() {
      return this.brand === PROJECT_BRANDS.muscleCharge;
    },
    getFooterText() {
      const textMap = {
        [PROJECT_BRANDS.reverse]: this.$t('landingPage.footer.text'),
        [PROJECT_BRANDS.muscleCharge]: this.$t('landingPage.footerMuscleCharge.text'),
      };

      return textMap[this.brand || PROJECT_BRANDS.reverse];
    },
    getInstagramLink() {
      const linksMap = {
        [PROJECT_BRANDS.reverse]: this.$t('links.insta'),
        [PROJECT_BRANDS.muscleCharge]: this.$t('links.MuscleCharge.insta'),
      };

      return linksMap[this.brand || PROJECT_BRANDS.reverse];
    },
    getFacebookLink() {
      const linksMap = {
        [PROJECT_BRANDS.reverse]: this.$t('links.fb'),
        [PROJECT_BRANDS.muscleCharge]: this.$t('links.MuscleCharge.fb'),
      };

      return linksMap[this.brand || PROJECT_BRANDS.reverse];
    },
    footerLinks() {
      return getFooterLinksByBrand(this.$getHelpCenterUrl);
    },
    privacyAndTermsLinks() {
      return getPrivacyAndTermsByBrand({ tosCb: this.tosUrl, ppUrlCb: this.ppUrl });
    },
  },
};
